import React from 'react';
import { AlertTriangle, Trash2, X } from 'lucide-react';
import { Button } from './UI';

export default function ConfirmModal({ isOpen, onClose, onConfirm, title, message, confirmLabel = 'Delete', variant = 'danger', loading = false }) {
  if (!isOpen) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/50" onClick={onClose} />
      <div className="relative bg-white rounded-xl shadow-xl w-full max-w-sm">
        <div className="p-6">
          <div className="flex items-start gap-4">
            <div className={`w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0 ${variant === 'danger' ? 'bg-red-100' : 'bg-yellow-100'}`}>
              {variant === 'danger' ? (
                <Trash2 size={20} className="text-red-600" />
              ) : (
                <AlertTriangle size={20} className="text-yellow-600" />
              )}
            </div>
            <div className="flex-1 min-w-0">
              <h3 className="text-base font-semibold text-gray-900">{title || 'Confirm Delete'}</h3>
              <p className="text-sm text-gray-500 mt-1">
                {message || 'Are you sure you want to delete this item? This action cannot be undone.'}
              </p>
            </div>
            <button onClick={onClose} className="p-1 rounded-lg hover:bg-gray-100 flex-shrink-0">
              <X size={16} className="text-gray-400" />
            </button>
          </div>
          <div className="flex justify-end gap-3 mt-6">
            <Button variant="secondary" onClick={onClose} disabled={loading}>Cancel</Button>
            <Button variant={variant === 'danger' ? 'danger' : 'primary'} onClick={onConfirm} loading={loading}>
              {confirmLabel}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
